import React, { useState, useRef, useCallback, useMemo, useEffect } from 'react';
import ReactFlow, {
  ReactFlowProvider,
  addEdge,
  useNodesState,
  useEdgesState,
  Controls,
  MarkerType,
  updateEdge,
  Background,
  MiniMap

} from 'reactflow';
import 'reactflow/dist/style.css';
import Button from '@mui/material/Button';
import MonitoringSidebar from './monitoringSidebar';
import SidebarConfig, { PrometheusConfig, ThanosConfig, ObjectStoreS3Config, ObjectStoreAzureBlobConfig, ObjectStoreGCSConfig, ObjectStoreMinioConfig } from './sidebarConfig';
import '../app.css';
import PrometheusNode from './prometheus';
import ThanosNode from './thanos'
import ClusterNode from './cluster'
import ObjectStoreNode from './objectStores'
import ObjectStoreSidebar from './objectSidebar'
import ThanosSidecar from './thanosSidecar'
import TemplateSideNav from './templateSideNav'
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import images from "./images";

import { SidecarTemplateNodes, SidecarTemplateEdges, ReceiverTemplateEdges, ReceiverTemplateNodes } from './sidecarModeTemplate'
let id = 0;
const getId = () => `dndnode_${id++}`;

const smallnodes = [
  {
    id: '1',
    data: { label: 'Hello' },
    position: { x: 0, y: 0 },
    type: 'input',
  },
  {
    id: '2',
    data: { label: 'World' },
    position: { x: 100, y: 100 },
  },
];

const DnDFlow = (props) => {
  const reactFlowWrapper = useRef(null);
  const edgeUpdateSuccessful = useRef(true);
  const { showTemplateNav, setShowTemplateNav } = props
  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);
  const [reactFlowInstance, setReactFlowInstance] = useState(null);
  const [target, setTarget] = useState(null);
  const [showNodeConfig, setShowNodeConfig] = useState(false)
  const [configNode, setConfigNode] = useState()
  const [openCluster, setOpenCluster] = useState(false);

  const [clusterName, setClusterName] = useState("");

  const handleClickOpen = () => {
    setOpenCluster(true);
  };
  const handleClose = () => {
    setOpenCluster(false);
  };

  const onConnect = ((params) => {
    const config = {
      label: '', animated: true, arrowHeadType: 'arrow', markerEnd: {
        type: MarkerType.ArrowClosed, width: 30,
        height: 30,
        color: '#FF0072',
      },
      style: {
        strokeWidth: 1,
        stroke: '#FF0072',
      },
      ...params
    };

    let sourceNode = nodes.find(n => n.id == params.source)
    let targetNode = nodes.find(n => n.id == params.target)
    if ((sourceNode && targetNode) && ((sourceNode.type == "prometheus" || sourceNode.type == "thanos") &&
      (targetNode.type == "S3" || targetNode.type == "GCS" || targetNode.type == "AZURE" || targetNode.type == "minio"))) {
      sourceNode.data.objStoreConfig = targetNode.data.name
    }
    if ((sourceNode && targetNode) && (sourceNode.type == "prometheus" && targetNode.type == "thanos") &&
      (sourceNode.data.mode == "" || sourceNode.data.mode == "sidecar")) {
      // remove receiver confid from Thanos node
      delete targetNode.data['receiver']
    }
    setEdges((eds) => addEdge(config, eds))
  });

  const nodeTypes = useMemo(() => ({
    prometheus: PrometheusNode,
    thanos: ThanosNode,
    cluster: ClusterNode,
    S3: ObjectStoreNode,
    GCS: ObjectStoreNode,
    AZURE: ObjectStoreNode,
    minio: ObjectStoreNode,
    sidecar: ThanosSidecar,
  }), []);

  const onDragOver = useCallback((event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
  }, []);

  useEffect(() => {
    setNodes((nds) =>
      nds.map((node) => {
        if (configNode && node.id === configNode.id) {
          node = { ...configNode };
        }
        return node;
      })
    );
  }, [configNode]);


  function downloadFile(content, filename, contentType) {
    if (!contentType) contentType = 'application/octet-stream';
    var a = document.createElement('a');
    var blob = new Blob([content], { 'type': contentType });
    a.href = window.URL.createObjectURL(blob);
    a.download = filename;
    a.click();
  }
  const onDrop = useCallback(
    (event) => {
      setShowTemplateNav(false)
      event.preventDefault();
      const reactFlowBounds = reactFlowWrapper.current.getBoundingClientRect();
      const type = event.dataTransfer.getData('application/reactflow');
      // check if the dropped element is valid
      if (typeof type === 'undefined' || !type) {
        return;
      }
      if (type == "templateSidecar") {
        setNodes(SidecarTemplateNodes)
        setEdges(SidecarTemplateEdges)
        id = SidecarTemplateNodes.length
        return
      } else if (type == "templateReceiver") {
        setNodes(ReceiverTemplateNodes)
        setEdges(ReceiverTemplateEdges)
        id = ReceiverTemplateNodes.length
        return
      }
      const position = reactFlowInstance.project({
        x: event.clientX - reactFlowBounds.left,
        y: event.clientY - reactFlowBounds.top,
      });
      const newNode = {
        id: getId(),
        type,
        position,
        data: { label: `${type} node` },
      };
      if (type == "prometheus") {
        PrometheusConfig.map(p => {
          newNode.data[p.key] = ""
        })
      }
      if (type == "thanos") {
        ThanosConfig.map(p => {
          if (p.type == "array") {
            newNode.data[p.key] = {}
            p.data.map(pp => {
              newNode.data[p.key][pp.key] = ""
            })
          } else {
            newNode.data[p.key] = ""
          }

        })
      }
      if (type == "S3") {
        ObjectStoreS3Config.map(p => {
          newNode.data[p.key] = ""
        })
      } else if (type == "AZURE") {
        ObjectStoreAzureBlobConfig.map(p => {
          newNode.data[p.key] = ""
        })
      } else if (type == "GCS") {
        ObjectStoreGCSConfig.map(p => {
          newNode.data[p.key] = ""
        })
      } else if (type == "minio") {
        ObjectStoreMinioConfig.map(p => {
          newNode.data[p.key] = ""
        })
      }
      if (type == "S3" || type == "AZURE" || type == "minio" || type == "GCS") {
        newNode.data.type = type
      }
      setNodes((nds) => nds.concat(newNode));
    },
    [reactFlowInstance]
  );

  const onNodeDragStop = (evt, node) => {
    if (node && (node.type == "S3" ||
      node.type == "GCS" ||
      node.type == "minio" ||
      node.type == "AZURE")) {
      return
    }
    if (target && target.type == 'cluster') {
      setNodes((nds) =>
        nds.map((n) => {
          if (n.id === node.id) {
            n.parentNode = target.id
            n.position = {
              x: 50,
              y: 50,
            }
            n.data.parentNode = target.id
            n.data.clusterName = target.data && target.data.clusterName
          }
          return n;
        })
      );
    }
    setTarget(null)
  };

  const onNodeClick = (event, node) => {
    // if (node.data["parentNode"] === undefined) {
    //   return
    // }
    if (node.type == "cluster") {
      setConfigNode(node)
    } else if (node.type == "thanos" || node.type == "prometheus") {
      setShowNodeConfig(!showNodeConfig)
      setConfigNode(node)
    } else if (node.type == "S3" || node.type == "GCS" ||
      node.type == "AZURE" || node.type == "minio") {
      setShowNodeConfig(!showNodeConfig)
      setConfigNode(node)
    }
  }

  const onNodeDrag = (evt, node) => {
    // calculate the center point of the node from position and dimensions
    const centerX = node.position.x + node.width / 2;
    const centerY = node.position.y + node.height / 2;

    // find a node where the center point is inside
    const targetNode = nodes.find(
      (n) =>
        centerX > n.position.x &&
        centerX < n.position.x + n.width &&
        centerY > n.position.y &&
        centerY < n.position.y + n.height &&
        n.id !== node.id // this is needed, otherwise we would always find the dragged node
    );
    setTarget(targetNode);
  };

  function onNodeAdd(cname) {
    setOpenCluster(true);
    setClusterName(cname)
  }

  function HandleDelete() {
    let removedChildIfAny = nodes.filter((node) => {
      return node.parentNode != configNode.id
    })
    let finalNodes = removedChildIfAny.filter((node) => {
      return node.id != configNode.id
    })
    setNodes(finalNodes)
    setOpenCluster(false)
    setClusterName("")
  };


  function HandleSave(nodeType) {
    if (configNode) {
      setNodes((nds) =>
        nds.map((n) => {
          if (n.id === configNode.id) {
            n.data.clusterName = clusterName
          }
          return n;
        })
      );
      setOpenCluster(false);
      setClusterName("")
      setConfigNode()
      return
    }

    let filteredNodes = nodes.filter(n => n.type === nodeType)
    let id = getId()
    const newNode = {
      id: id,
      type: nodeType,
      data: { label: '', nodeId: filteredNodes.length + 1, id: id, clusterName: clusterName, setOpen: onNodeAdd },
      position: {
        x: Math.random() * window.innerWidth - 250,
        y: Math.random() * window.innerHeight - 250,
      },
    };
    setNodes((nds) => nds.concat(newNode));
    setOpenCluster(false);
    setClusterName("")
  };



  function exportValues(event) {
    let clusters = []
    let objStores = []
    nodes.map(n => {
      if (n.type != "cluster") {
        let anode = {}
        anode.name = n.data.clusterName
        anode.type = n.type
        let dData = n.data
        switch (true) {
          case dData.label.includes("thanos"):
            anode.data = {}
            Object.keys(dData).forEach(function (key) {
              for (let i = 0; i < ThanosConfig.length; i++) {
                if (key == ThanosConfig[i]["key"]) {
                  anode.data[key] = n.data[key]
                }
              }
            })
            clusters.push(anode)
            break;
          case dData.label.includes("prom"):
            anode.data = {}
            Object.keys(dData).forEach(function (key) {
              for (let i = 0; i < PrometheusConfig.length; i++) {
                if (key == PrometheusConfig[i]["key"]) {
                  anode.data[key] = n.data[key]
                }
              }
            })
            clusters.push(anode)
            break;
          case dData.label.includes("S3"):
            anode.config = {}
            anode.name = n.data.name
            Object.keys(dData).forEach(function (key) {
              for (let i = 0; i < ObjectStoreS3Config.length; i++) {
                if (key == ObjectStoreS3Config[i]["key"] && key != "name") {
                  anode.config[key] = n.data[key]
                }
              }
            })
            objStores.push(anode)
            break;
          case dData.label.includes("GCS"):
            anode.config = {}
            anode.name = n.data.name
            Object.keys(dData).forEach(function (key) {
              for (let i = 0; i < ObjectStoreGCSConfig.length; i++) {
                if (key == ObjectStoreGCSConfig[i]["key"]&& key != "name") {
                  anode.config[key] = n.data[key]
                }
              }
            })
            objStores.push(anode)
            break;
          case dData.label.includes("AZURE"):
            anode.name = n.data.name
            anode.config = {}
            Object.keys(dData).forEach(function (key) {
              for (let i = 0; i < ObjectStoreAzureBlobConfig.length; i++) {
                if (key == ObjectStoreAzureBlobConfig[i]["key"]&& key != "name") {
                  anode.config[key] = n.data[key]
                }
              }
            })
            objStores.push(anode)
            break;
          case dData.label.includes("minio"):
            anode.config = {}
            anode.name = n.data.name
            Object.keys(dData).forEach(function (key) {
              for (let i = 0; i < ObjectStoreMinioConfig.length; i++) {
                if (key == ObjectStoreMinioConfig[i]["key"]&& key != "name") {
                  anode.config[key] = n.data[key]
                }
              }
            })
            objStores.push(anode)
            break;
        }
      }
    })
    const YAML = require('yaml');
    const doc = new YAML.Document();
    let kriusConfig = {}
    kriusConfig.clusters = clusters
    kriusConfig.objStoreConfigslist = objStores
    doc.contents = kriusConfig;
    downloadFile(doc.toString(), "kriusConfig.yaml")
  }

  function addSidecar(prometheusNode) {
    const newNode = {
      id: getId(),
      type: "sidecar",
      data: { label: '' },
      parentNode: prometheusNode.parentNode,
      position: {
        x: 50,
        y: 200,
      }
    };
    setNodes((nds) => nds.concat(newNode));
  }

  function removeSidecar(prometheusNode) {
    let nn = [...nodes]
    let sidecarNode = nn.find(n => n.parentNode == prometheusNode.parentNode && n.type == "sidecar")
    let nodeToRemove = nn.indexOf(sidecarNode)
    if (nodeToRemove > -1) {
      nn.splice(nodeToRemove, 1)
      setNodes(nn)
    }
  }

  const onEdgeUpdateStart = useCallback(() => {
    edgeUpdateSuccessful.current = false;
  }, []);

  const onEdgeUpdate = useCallback((oldEdge, newConnection) => {
    edgeUpdateSuccessful.current = true;
    setEdges((els) => updateEdge(oldEdge, newConnection, els));
  }, []);

  const onEdgeUpdateEnd = useCallback((_, edge) => {
    if (!edgeUpdateSuccessful.current) {
      setEdges((eds) => eds.filter((e) => e.id !== edge.id));
    }
    edgeUpdateSuccessful.current = true;
  }, []);

  const onNodeDelete = (event, node) => {
    setNodes((nds) => nodes.filter(function (n) {
      return n.id != node.id
    }))
    setShowNodeConfig(false)
  }
  return (
    <div style={{
      borderTop: "1px solid #d9d9d9",
    }}
      className="canvas"
    >
      <div className="dndflow">
        {showTemplateNav &&
          <TemplateSideNav setShowTemplateNav={setShowTemplateNav} />
        }
        <div>
          <div style={{ display: 'grid', padding: 10 }} >
            <div className="description-2">
              <span style={{ padding: 10, color: 'black' }}>
                <u>Actions</u>
              </span>
              <img
                src={images.SettingsGear}
                height="14px"
                style={{ marginLeft: -7, marginTop: 10 }}
              />
            </div>
            <Button variant="outlined" style={{ height: 25, textTransform: 'capitalize' }}
              onClick={(event) => setOpenCluster(true)}>
              Add Cluster
            </Button>
            <Button variant="outlined" style={{ marginTop: "10px", height: 25, textTransform: 'capitalize' }}
              onClick={(event) => exportValues(event)}>
              Export values
            </Button>
          </div>
          <div className="draggable-stack">
            <MonitoringSidebar />
            <ObjectStoreSidebar />
          </div>

          <div className='hints'><span><u>Few hints for inter-cluster connectivity</u></span>
            <ul>
              <li>connect the right side of component to left side of other component </li>
              <li>update the configuration of component first, then make the connection</li>
            </ul>
          </div>
        </div>

        <ReactFlowProvider>
          <div className="reactflow-wrapper" ref={reactFlowWrapper}>
            <ReactFlow
              nodes={nodes}
              edges={edges}
              nodeTypes={nodeTypes}
              onInit={setReactFlowInstance}
              onNodesChange={onNodesChange}
              onEdgesChange={onEdgesChange}
              onConnect={onConnect}
              onDrop={onDrop}
              onDragOver={onDragOver}
              onNodeDragStop={onNodeDragStop}
              onNodeDrag={onNodeDrag}
              onNodeClick={onNodeClick}
              onEdgeUpdate={onEdgeUpdate}
              onEdgeUpdateStart={onEdgeUpdateStart}
              onEdgeUpdateEnd={onEdgeUpdateEnd}
              className="touchdevice-flow"
            >
              <MiniMap />
              <Background />
            </ReactFlow>
          </div>
        </ReactFlowProvider>
        {showNodeConfig &&
          <SidebarConfig
            key={configNode && configNode.id}
            setConfigNode={setConfigNode}
            configNode={configNode}
            setShowNodeConfig={setShowNodeConfig}
            onNodeDelete={onNodeDelete}
            addSidecar={addSidecar}
            removeSidecar={removeSidecar}
          />}
      </div>


      <Dialog open={openCluster} onClose={handleClose}>
        <IconButton
          aria-label="close"
          onClick={() => handleClose()}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogTitle>Cluster</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Kubernetes cluster details
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="K8s cluster name"
            type="text"
            fullWidth
            variant="standard"
            defaultValue={clusterName}
            required
            onChange={(e) => setClusterName(e.target.value)}

          />
        </DialogContent>
        <DialogActions>

          <Button variant="contained"
            onClick={() => HandleSave("cluster")}
            disabled={clusterName == "" ? true : false}>Save</Button>

          <Button
            onClick={HandleDelete}
          >Delete cluster</Button>
        </DialogActions>
      </Dialog>

    </div>
  );
};

export default DnDFlow;
